"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { ArrowRight, X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function AnnouncementBanner() {
  const $ = _c(9);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const result = localStorage.getItem("isAnnouncementBannerVisible");
      setTimeout(() => setIsBannerVisible(result === "true" || result === null), 0);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isBannerVisible) {
    t2 = function toggleBanner() {
      const newValue = !isBannerVisible;
      setIsBannerVisible(newValue);
      localStorage.setItem("isAnnouncementBannerVisible", String(newValue));
    };
    $[2] = isBannerVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleBanner = t2;
  if (!isBannerVisible) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="#best-selling" className="group flex items-center justify-between gap-2">✨<Button variant="link" className="h-fit p-0 text-slate-800">Get our best-selling course<ArrowRight size={16} className="ml-1 transform transition group-hover:translate-x-1" /></Button>✨</Link>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <X size={16} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== toggleBanner) {
    t6 = <div className="flex w-full items-center justify-between bg-landingPageAccent px-4 py-2 text-sm text-slate-800">{t3}{t4}<div className="cursor-pointer" onClick={toggleBanner}>{t5}</div></div>;
    $[7] = toggleBanner;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}